var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 16.5H16.5C15.2574 16.5 14.25 17.5074 14.25 18.75V29.25C14.25 30.4926 15.2574 31.5 16.5 31.5H31.5C32.7426 31.5 33.75 30.4926 33.75 29.25V18.75C33.75 17.5074 32.7426 16.5 31.5 16.5Z",
    stroke: "#1B2559",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 18.75L24 25.5L33.75 18.75",
    stroke: "#1B2559",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default __webpack_public_path__ + "static/media/Templates.191f9c96e286082c8ccbc3157bf25137.svg";
export { ForwardRef as ReactComponent };